import { AxiosRequestConfig } from 'axios';
import { currentLanguage } from 'shared/constants/common';
import { findCookieValue, getRegisterMethod } from 'shared/util/utility';

const BestSellerApiWrapper = (requests: any) => {
	// const Cookies:any = document.cookie;
	return {
		taxCalculation: (body: any) => {
			const config: AxiosRequestConfig = {
				headers: {
					'Request-Language': currentLanguage,
					'x-odds-session': findCookieValue('x-odds-session'),
				},
			};
			return requests.post(`/betting/calculate-tax-winning/${getRegisterMethod()}`, body, config);
		},
		betPlace: (body: any) => {
			const config: AxiosRequestConfig = {
				headers: {
					'Request-Language': currentLanguage,
					'x-odds-session': findCookieValue('x-odds-session'),
				},
			};
			return requests.post(`/betting/place-bet/${getRegisterMethod()}`, body, config);
		},
		validationOdds: (ids: number[] | string[]) => {
			const config: AxiosRequestConfig = {
				headers: {
					'Request-Language': currentLanguage,
					'x-odds-session': findCookieValue('x-odds-session'),
				},
			};
			return requests.get(`/betting/custom-bet/validate?outcomeIds=${ids}`, config);
		},
		getOutcomeData: (body: any) => {
			const config: AxiosRequestConfig = {
				headers: {
					'Request-Language': currentLanguage,
					'x-odds-session': findCookieValue('x-odds-session'),
				},
			};
			return requests.post('/virtuals/generate-outcomes', body, config);
		},
		calculateOdds: (ids: number[]) => {
			const config: AxiosRequestConfig = {
				headers: {
					'Request-Language': currentLanguage,
					'x-odds-session': findCookieValue('x-odds-session'),
				},
			};
			return requests.get(`/betting/custom-bet/calculate?outcomeIds=${ids}`, config);
		},

		updateCustomBets: (id: number) => {
			const config: AxiosRequestConfig = {
				headers: {
					'Request-Language': currentLanguage,
					'x-odds-session': findCookieValue('x-odds-session'),
				},
			};
			return requests.get(`/betting/custom-bet/update-odds/${id}`, config);
		},

		approveBets: (body: any) => {
			const config: AxiosRequestConfig = {
				headers: {
					'Request-Language': currentLanguage,
					'x-odds-session': findCookieValue('x-odds-session'),
				},
			};
			return requests.post(`betting/approve-bet/${getRegisterMethod()}`, body, config);
		},
		approvedSlips: () => {
			const config: AxiosRequestConfig = {
				headers: {
					'Request-Language': currentLanguage,
					'x-odds-session': findCookieValue('x-odds-session'),
				},
			};
			return requests.get('/customer/session/approved-slips', config);
		},
	};
};

export default BestSellerApiWrapper;
